import { Component, OnInit, OnDestroy, QueryList, ViewChildren } from '@angular/core';
import Swal from 'sweetalert2';
import { Subject } from 'rxjs';
import { DTConfig } from 'src/app/Class/DTConfig ';
import { DataTableDirective } from 'angular-datatables';
import { DocumentosService } from 'src/app/servicios/documentos.service';
import { Loading } from 'src/app/Class/Loading';
declare var $: any;

@Component({
  selector: 'app-listado-solicitudes',
  templateUrl: './listado-solicitudes.component.html',
  styleUrls: ['./listado-solicitudes.component.css']
})
export class ListadoSolicitudesComponent implements OnInit {
  public dtOptions: DataTables.Settings[] = [ DTConfig.dtConf, DTConfig.dtConf, DTConfig.dtConf, DTConfig.dtConf ];
  public dtTrigger: Subject<any> = new Subject();
  index: number;
  public errores = [];
  public server = '';
  Toast = Swal.mixin({ toast: true, position: 'top-end', showConfirmButton: false, timer: 3000 });
  @ViewChildren(DataTableDirective)
  dtElements: QueryList<DataTableDirective>;

  public solicitudes: any = [];
  public listadoNuevas: any = [];
  public listadoAprobadas: any = [];
  public listadoRechazadas: any = [];

  constructor(private documentoService: DocumentosService, public loading: Loading) { 
    this.getListado(false);
    
  }



  ngOnInit() {
  }
  ngOnDestroy(): void { this.dtTrigger.unsubscribe(); }
  rerender(): void {
    this.dtElements.forEach((dtElement: DataTableDirective) => {
      dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
        dtInstance.destroy();
        this.dtTrigger.next();
      });
    });
  }
  getListado(render) {
    this.loading.estado = true;
    this.documentoService.GetListadoSolicitudes().subscribe(datos => {
      this.listadoNuevas = datos['listadoNuevas'];
      this.listadoRechazadas = datos['listadoRechazadas'];
      this.listadoAprobadas = datos['listadoAprobadas'];
      if (render) {
        this.Toast.fire({ type: 'success', title: 'Listados actualizados exitosamente' });
        this.rerender();
      }
     this.dtTrigger.next();
     this.loading.estado = false;
      
      
    }),
    err => {  this.loading.estado = false; };
  }
}
